// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".skeleton-card[data-v-00498fac]{border:1px solid #e2e8f0;border-radius:20px;height:220px;width:220px}.skeleton-details[data-v-00498fac]{align-items:center;display:flex;flex-direction:column;height:100%;justify-content:space-between}.animate-pulse[data-v-00498fac]{animation:pulse-00498fac 1.5s ease-in-out infinite}@keyframes pulse-00498fac{0%,to{opacity:1}50%{opacity:.5}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
